var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.959 0.660103C11.8259 0.556347 11.662 0.5 11.4932 0.5C11.3245 0.5 11.1606 0.556347 11.0275 0.660103L0.25 9.06385L1.18225 10.2429L2.5 9.21535V18.4996C2.50079 18.8972 2.65908 19.2783 2.94022 19.5594C3.22135 19.8405 3.60242 19.9988 4 19.9996H19C19.3976 19.9988 19.7787 19.8405 20.0598 19.5594C20.3409 19.2783 20.4992 18.8972 20.5 18.4996V9.2221L21.8177 10.2496L22.75 9.0706L11.959 0.660103ZM13 18.4996H10V12.4996H13V18.4996ZM14.5 18.4996V12.4996C14.4996 12.1019 14.3414 11.7206 14.0602 11.4394C13.779 11.1582 13.3977 11 13 10.9996H10C9.6023 11 9.221 11.1582 8.93978 11.4394C8.65856 11.7206 8.5004 12.1019 8.5 12.4996V18.4996H4V8.0461L11.5 2.2036L19 8.0536V18.4996H14.5Z",
    fill: "#1A1003",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0881f88e84f9a320d4a17e22cc9ad359.svg";
export { ForwardRef as ReactComponent };